import React from 'react';
import { Phone, Sparkles } from 'lucide-react';

/**
 * One WhatsApp button + one AI chat button. No labels, no tooltips.
 * Mobile: hidden until user scrolls past hero so they don't overlap hero CTA.
 * Desktop: always visible.
 */
export const FloatingButtons = ({
  visible,
  isOpen,
  onOpenChat,
  onDirectWhatsApp
}) => {
  const containerClass = `fixed bottom-24 right-4 z-[60] flex flex-col items-end gap-3 md:bottom-8 md:right-8 md:flex transition-opacity duration-300 ${
    visible
      ? 'opacity-100 pointer-events-auto'
      : 'opacity-0 md:opacity-100 pointer-events-none md:pointer-events-auto'
  }`;

  return (
    <div className={containerClass}>
      <button
        type="button"
        onClick={onDirectWhatsApp}
        className="w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#20BF5B] text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] flex items-center justify-center transition-colors duration-200"
        aria-label="WhatsApp"
        data-testid="direct-whatsapp-fab"
      >
        <Phone className="w-5 h-5" strokeWidth={2} />
      </button>

      {!isOpen && (
        <button
          type="button"
          onClick={onOpenChat}
          className="w-12 h-12 rounded-full bg-gradient-to-br from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black shadow-[0_8px_24px_rgba(212,175,55,0.35)] flex items-center justify-center transition-transform duration-200 hover:scale-105"
          aria-label="Open AI chat with Nitika"
          data-testid="chat-fab"
        >
          <Sparkles className="w-5 h-5" strokeWidth={1.75} />
        </button>
      )}
    </div>
  );
};
